import i18n from "@/plugins/i18n";

import moment from "moment";

const keyCodesAllow = [8, 46, 37, 38, 39, 40];

export function onlyNumeric(event) {
  let keyCode = event.which;
  if (!keyCodesAllow.includes(keyCode) && (keyCode < 48 || keyCode > 57)) {
    event.preventDefault();
  }
}

export function onlyDecimal(event, value, maxlength) {
  let keyCode = event.which;
  if ((keyCode < 48 && keyCode !== 46) || keyCode > 57) {
    event.preventDefault();
    return;
  }
  if (value) {
    value += "";
    value = value.replace(/[^0-9\.]/g, "") + "";
    if (value.length > maxlength - 1) {
      event.preventDefault();
    }
  }
}

export function formatNumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  if (!isNumeric(number)) {
    return number;
  }
  var value = Number(number);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function NumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  try {
    var value = Number(number);
    var nf = new Intl.NumberFormat();
    return nf.format(value);
  } catch (error) {
    return number;
  }
}

export function toASCII(chars) {
  if (chars === undefined || chars === null || chars === "") {
    return chars;
  }
  chars = chars.replace("ー", "-");
  chars = chars.replace("。", ".");
  let ascii = "";
  for (let i = 0, l = chars.length; i < l; i++) {
    let c = chars[i].charCodeAt(0);
    if (c >= 0xff00 && c <= 0xffef) {
      c = 0xff & (c + 0x20);
    }
    ascii += String.fromCharCode(c);
  }
  ascii = ascii.replace("−", "-");
  return ascii;
}

export function required(v, fieldName) {
  return !!v || v === 0 || i18n.t("msg.required", [fieldName]);
}

export function requiredFile(v, fieldName) {
  return (v) => (v && v.size > 0) || i18n.t("msg.requireFile", [fieldName]);
}

export function requiredArr(v, fieldName) {
  return (v && v.length > 0) || i18n.t("msg.required", [fieldName]);
}

export function requiredNumber(v, fieldName) {
  return !!v || v === 0 || i18n.t("msg.requiredNumber", [fieldName]);
}

export function maxLength(v, fieldName, MAX_LENGTH) {
  if (!v) {
    return true;
  }
  return (
    (`${v}` || "").length <= MAX_LENGTH ||
    i18n.t("msg.maxLength", [fieldName, MAX_LENGTH])
  );
}

export function onlyNumber(v, fieldName) {
  if (v) {
    return isNumeric(v) || i18n.t("msg.onlyNumber", [fieldName]);
  }
  return true;
}

export const EXCEL_EXTENSIONS = ["xls", "xlsx", "XLS", "XLSX"];

export function isExcelFile(v) {
  if (!v) {
    return false;
  }
  let array = v.split(".");
  let extension = array[array.length - 1];
  if (!EXCEL_EXTENSIONS.includes(extension)) {
    return false;
  } else {
    return true;
  }
}

export function isValidUrl(v, fieldName) {
  var pattern =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9ぁ-ゔ一-龠ァ-ヴーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９ ⑩ ⑪ ⑫ ⑬ ⑭ ⑮ ⑯ ⑰ ⑱ ⑲ ⑳ ⓪ ① ② ③ ④ ⑤ ⑥ ⑦ ⑧ ⑨【】 、 ・ ～ 々〆〤ヶ@:%._\+~#=]{1,256}\.[a-zA-Z0-9ぁ-ゔ一-龠ァ-ヴーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９⑩ ⑪ ⑫ ⑬ ⑭ ⑮ ⑯ ⑰ ⑱ ⑲ ⑳ ⓪ ① ② ③ ④ ⑤ ⑥ ⑦ ⑧ ⑨ 【】 、 ・ ～ 々〆〤ヶ()]{1,6}\b(?:[-a-zA-Z0-9ぁ-ゔ一-龠ァ-ヴーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９ ⑩ ⑪ ⑫ ⑬ ⑭ ⑮ ⑯ ⑰ ⑱ ⑲ ⑳ ⓪ ① ② ③ ④ ⑤ ⑥ ⑦ ⑧ ⑨ 【】 、 ・ ～ 々〆〤ヶ()@:%_\+.~#?&\/=]*)$/; // fragment locator
  if (v && v.trim().length > 0 && !pattern.test(v)) {
    return i18n.t("msg.invalidUrl", [fieldName]);
  } else {
    return true;
  }
}

export function validColumnId(v, fieldName) {
  var pattern = /^([a-zA-Z])+$/;
  if (v && v.trim().length > 0 && !pattern.test(v)) {
    return i18n.t("msg.invalidColumnId", [fieldName]);
  } else {
    return true;
  }
}

//(column,row)
export function validCellFormat(v, fieldName) {
  var patternCharacter = /^([a-zA-Z])+$/;
  var patternNumber = /^([0-9])+$/;
  if (!v) {
    return i18n.t("msg.invalidCellId", [fieldName]);
  }
  let arr = v.split(",");
  if (!arr || arr.length !== 2) {
    return i18n.t("msg.invalidCellId", [fieldName]);
  }
  let column = arr[0];
  let cell = arr[1];
  if (column && column.trim().length > 0 && !patternCharacter.test(column)) {
    return i18n.t("msg.invalidCellId", [fieldName]);
  }

  if (
    cell &&
    cell.trim().length > 0 &&
    (!patternNumber.test(cell) || Number.parseInt(cell) === 0)
  ) {
    return i18n.t("msg.invalidCellId", [fieldName]);
  }

  return true;
}

export function compareStartEndTime(v1, v2, fieldName1, fieldName2) {
  if (!v1 || !v2 || v1 < v2) {
    return true;
  }
  return i18n.t("msg.validStartEndTime", [fieldName1, fieldName2]);
}

export function requiredTime(v1, v2, fieldName) {
  return v1 && !v2 ? i18n.t("msg.required", [fieldName]) : true;
}

export function valueInputBetween(v, fieldName, min, max) {
  if (v || v === 0) {
    return (
      (v >= min && v <= max) ||
      i18n.t("msg.valueInputBetween", [fieldName, min, max])
    );
  }
  return true;
}

export function negativeNumber(v, fieldName) {
  if (!!v) {
    return (
      (isNumeric(v) && parseInt(v) > 0) ||
      i18n.t("msg.requirePositiveNumber", [fieldName])
    );
  }
  return true;
}

export function maxFileSize(v, fieldName) {
  return !v || v.size / 1024 / 1024 <= 5 || i18n.t("msg.overFileSize", [5]);
}

export function getTaskStatusById(id) {
  return !id ? "" : id == 1 ? "成功" : "失敗";
}

export function formatName(name) {
  if (!name) {
    return "";
  }
  let nameArr = name.split(",");
  return nameArr.length > 2
    ? nameArr.slice(0, 2).join("<br>") + "..."
    : nameArr.join("<br>");
}

export function formatNameUniq(name) {
  if (!name) {
    return "";
  }
  let nameArr = name.split(",");
  let nameSet = [...new Set(nameArr)];
  let nameUniq = Array.from(nameSet);
  return nameUniq.length > 2
    ? nameUniq.slice(0, 2).join("<br>") + "..."
    : nameUniq.join("<br>");
}

export function scroll2BottomByElementId(elementId) {
  this.$nextTick(() => {
    let element = document.getElementById(elementId + "");
    if (!element) {
      return;
    }
    element.scrollIntoView({
      top: 0,
      behavior: "smooth",
    });
  });
}
